<template>
  <div>
    <div class="my-gallery row" itemscope itemtype="http://schema.org/ImageGallery">
      <figure :id="item.id" :class="amountCss" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject" v-for="(item, index) in items" :src="item.thumbnail" v-bind:key="index">
        <a :href="item.src" itemprop="contentUrl" :data-size="'' + width + 'x' + height" :title="item.title">
          <img v-if="isPicture(item.src)" :src="item.thumbnail" :alt="item.alt" itemprop="thumbnail" />
          <video v-else ref="videoRef" :src="item.thumbnail" width="100%" height="240" controls :poster="videoPreview(item.thumbnail)" :alt="item.alt" itemprop="thumbnail"></video>
        </a>
        <!-- 超過四張顯示 + 幾 -->
        <div v-if="item.id === 3 && items.length > 4" class="more-picture">+ {{ items.length - 3 }}</div>
      </figure>
    </div>

    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="pswp__bg"></div>
      <div class="pswp__scroll-wrap">
        <div class="pswp__container">
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
          <div class="pswp__item"></div>
        </div>
        <div class="pswp__ui pswp__ui--hidden">
          <div class="pswp__top-bar">
            <div class="pswp__counter"></div>
            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

            <button class="pswp__button pswp__button--rotate pswp__button--rotate--left" title="Rotate left" v-if="options.rotationOn" @click="rotate(-90)"></button>
            <button class="pswp__button pswp__button--rotate pswp__button--rotate--right" title="Rotate right" v-if="options.rotationOn" @click="rotate(90)"></button>

            <!-- <button class="pswp__button pswp__button--share" title="Share"></button> -->
            <!-- <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> -->
            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
            <!-- 客製更多功能按鈕 -->
            <!-- <button class="pswp__button--trash" @click="showTool(photoId)">
              <i class="far fa-ellipsis-h"></i>
            </button> -->
            <!-- 客製下載按鈕 -->
            <!-- <button class="pswp__button--download" @click="saveImg(url)">
              <i class="far fa-arrow-to-bottom"></i>
            </button> -->
            <!-- 客製刪除按鈕 -->
            <!-- <button class="pswp__button--trash" @click="deleteThisPhoto(photoId)">
              <i class="fal fa-trash-alt"></i>
            </button> -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip"></div>
          </div>
          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" @click="resetAngle"></button>
          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)" @click="resetAngle"></button>
          <div class="pswp__caption">
            <div class="pswp__caption__center"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 刪除 alert -->
    <!-- <q-dialog v-model="confirm" persistent>
      <q-card class="q-py-md" style="width: 90%">
        <q-card-section class="row items-center">
          <span class="q-ml-sm q-mx-auto">您確定要刪除此張相片嗎?</span>
        </q-card-section>

        <q-card-actions align="center" class="justify-around">
          <q-btn flat label="刪除" color="negative" @click="deleteThisPhoto(photoId)" v-close-popup />
          <q-btn flat label="取消" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog> -->
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'PostPictureSwipe',
  props: {
    items: {
      default: () => [],
      type: Array
    },
    options: {
      default: () => ({}),
      type: Object
    },
    singleThumbnail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pswp: null,
      angle: 0,
      photoId: '',
      url: '',
      width: window.innerWidth * 5,
      height: window.innerHeight * 5,
      confirm: false,
      selection: []
    };
  },
  computed: {
    // 依據照片數量來決定顯示的圖片排版
    amountCss() {
      let imgLength = this.items.length;
      if (imgLength === 1) {
        return 'picture-1';
      } else if (imgLength === 2) {
        return 'picture-2';
      } else if (imgLength === 3) {
        return 'picture-3';
      } else if (imgLength === 4) {
        return 'picture-4';
      } else {
        // 超過四張
        return 'picture-5';
      }
    }
  },
  mounted() {
    const that = this;
    const initPhotoSwipeFromDOM = function(gallerySelector) {
      // parse slide data (url, title, size ...) from DOM elements
      // (children of gallerySelector)
      const parseThumbnailElements = function(el) {
        const thumbElements = el.childNodes;
        const numNodes = thumbElements.length;
        const items = [];
        let figureEl;
        let linkEl;
        let size;
        let item;

        for (let i = 0; i < numNodes; i++) {
          figureEl = thumbElements[i]; // <figure> element

          // include only element nodes
          if (figureEl.nodeType !== 1) {
            continue;
          }

          linkEl = figureEl.children[0]; // <a> element

          size = linkEl.getAttribute('data-size').split('x');

          // create slide object
          item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10),
            title: linkEl.getAttribute('title')
          };

          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML;
          }

          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
          }

          item.id = figureEl.getAttribute('id');

          item.el = figureEl; // save link to element for getThumbBoundsFn
          items.push(item);
        }

        return items;
      };

      // find nearest parent element
      const closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
      };

      // triggers when user clicks on thumbnail
      const onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : (e.returnValue = false);

        const eTarget = e.target || e.srcElement;

        // find root element of slide
        const clickedListItem = closest(eTarget, function(el) {
          return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
        });

        if (!clickedListItem) {
          return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        const clickedGallery = clickedListItem.parentNode;
        const childNodes = clickedListItem.parentNode.childNodes;
        const numChildNodes = childNodes.length;
        let nodeIndex = 0;
        let index;

        for (let i = 0; i < numChildNodes; i++) {
          if (childNodes[i].nodeType !== 1) {
            continue;
          }

          if (childNodes[i] === clickedListItem) {
            index = nodeIndex;
            break;
          }
          nodeIndex++;
        }

        if (index >= 0) {
          // open PhotoSwipe if valid index found
          openPhotoSwipe(index, clickedGallery);
        }
        return false;
      };

      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      const photoswipeParseHash = function() {
        const hash = window.location.hash.substring(1);
        const params = {};

        if (hash.length < 5) {
          return params;
        }

        const vars = hash.split('&');
        for (let i = 0; i < vars.length; i++) {
          if (!vars[i]) {
            continue;
          }
          const pair = vars[i].split('=');
          if (pair.length < 2) {
            continue;
          }
          params[pair[0]] = pair[1];
        }

        if (params.gid) {
          params.gid = parseInt(params.gid, 10);
        }

        return params;
      };

      const openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        const pswpElement = galleryElement.parentElement.querySelector('.pswp');

        const items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        const options = {
          // define gallery index (for URL)
          galleryUID: galleryElement.getAttribute('data-pswp-uid'),

          getThumbBoundsFn: function(index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            const thumbnail = items[index].el.getElementsByTagName('img')[0]; // find thumbnail
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            const rect = thumbnail.getBoundingClientRect();

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        };

        // PhotoSwipe opened from URL
        if (fromURL) {
          if (options.galleryPIDs) {
            // parse real index when custom PIDs are used
            // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
            for (let j = 0; j < items.length; j++) {
              if (items[j].pid === index) {
                options.index = j;
                break;
              }
            }
          } else {
            // in URL indexes start from 1
            options.index = parseInt(index, 10) - 1;
          }
        } else {
          options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
          return;
        }

        if (disableAnimation) {
          options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, Object.assign(options, that.options));
        gallery.init();
        // gallery.listen('gettingData', function(index, item) {
        //   if (item.w < 1 || item.h < 1) {
        //     // unknown size
        //     const img = new Image()
        //     img.onload = function() {
        //       // will get size after load
        //       item.w = this.width // set image width
        //       item.h = this.height // set image height
        //       gallery.invalidateCurrItems() // reinit Items
        //       gallery.updateSize(true) // reinit Items
        //     }
        //     img.src = item.src // let's download image
        //   }
        // })
        that.url = gallery.currItem.src;
        that.photoId = gallery.currItem.id;
        gallery.listen('afterChange', function() {
          that.url = gallery.currItem.src;
          that.photoId = gallery.currItem.id;
        });

        that.pswp = gallery;
      };

      // loop through all gallery elements and bind events
      const galleryElements = document.querySelectorAll(gallerySelector);

      for (let i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
      }

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      const hashData = photoswipeParseHash();
      if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
      }
    };

    initPhotoSwipeFromDOM('.my-gallery');
  },
  methods: {
    ...mapActions('albumModule', ['deleteApiOnePhoto']),
    ...mapMutations('albumModule', ['UPDATED_CHECKBOXVAL']),
    rotate: function(newAngle) {
      this.angle = this.angle + newAngle;
      this.$el.querySelectorAll('.pswp__img').forEach(i => (i.style.transform = `rotate(${this.angle}deg)`));
    },
    resetAngle: function() {
      this.angle = 0;
      this.$el.querySelectorAll('.pswp__img').forEach(i => (i.style.transform = `rotate(${this.angle}deg)`));
    },
    // 刪除相片
    deleteThisPhoto(photoId) {
      // 呼叫刪除的 API
      this.deleteApiOnePhoto(photoId);

      // 前端顯示面的刪除處理
      const delIndex = this.pswp.items
        .map(item => {
          return item.id;
        })
        .indexOf(photoId);

      if (this.pswp.items.length <= 1) {
        // 相簿內只剩最後一張相片，且正要刪除他時
        this.pswp.close();
        this.pswp.items.splice(delIndex, 1);
      } else {
        if (this.pswp.items.length - 1 === delIndex) {
          // 刪除相簿內最後一張相片後要回到第一張相片
          this.pswp.goTo(0);
        }
        this.pswp.items.splice(delIndex, 1);
        this.pswp.invalidateCurrItems();
        this.pswp.updateSize(true);
      }
    },
    // 儲存圖片(呼叫 app 端 js 請 app 執行下載圖片)
    saveImg(url) {
      const data = JSON.stringify({
        photos: [url]
      });
      if (this.checkIos) {
        // ios
        window.webkit.messageHandlers.downloadPhotoFromWeb.postMessage(data);
      } else {
        window.LaleTon.downloadPhotoFromWeb(data);
      }
    },
    // 叫出工具列表
    showTool(albumId) {
      this.$q
        .bottomSheet({
          albumId,
          actions: [
            {
              id: 'download',
              label: '下載相片',
              icon: 'far fa-arrow-to-bottom'
              // color: 'secondary'
            },
            {
              id: 'delete',
              label: '刪除相片',
              icon: 'fal fa-trash-alt'
              // color: 'negative'
            }
          ]
        })
        .onOk(action => {
          if (action.id === 'download') {
            this.saveImg(this.url);
          } else if (action.id === 'delete') {
            // 叫出確認視窗
            this.confirm = true;
          }
        })
        .onCancel(() => {
          // console.log('Dismissed')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    },
    // 判斷是影片還是相片
    isPicture(target) {
      let string = target.split('/tempImg')[1];
      // 判斷 . 後面的附檔名為何
      if (string.split('.')[1] === 'mp4' || string.split('.')[1] === 'mov') {
        return false;
      }
      return true;
    },

    // 取得 video 的縮圖
    videoPreview(item) {
      return item.replace('.mp4', '.jpg');
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/styles/quasar.variables';
.pswp__top-bar {
  text-align: right;
}
.pswp__caption__center {
  text-align: center;
}
.pswp__button--rotate {
  /* background: url(./icons/rotate.png) 0 0 no-repeat; */
  background-size: 62px 24px;
}
.pswp__button--rotate--left {
  background-position: 8px 10px;
}
.pswp__button--rotate--right {
  background-position: -26px 10px;
}

// 預設隱藏所有的 figure，再藉由 :nth-child(-n+4) 顯示前四張圖片
figure {
  display: none;
  margin: 0px;
  border: solid 1px #ffffff;
  border-radius: 6px;
  position: relative;
}

figure:nth-child(-n + 4) {
  display: inline;
}

figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.checkbox-div {
  position: absolute;
  right: 5px;
}

.pswp__button--trash,
.pswp__button--download {
  position: relative;
  overflow: visible;
  border: 0;
  padding: 0;
  margin: 0;
  float: right;
  transition: opacity 0.2s;
  box-shadow: none;
  background-size: 264px 88px;
  width: 44px;
  height: 44px;
  background-color: transparent;
  color: #ffffff8f;
  font-size: 18px;
}

.pswp__button--trash a,
.pswp__button--download a {
  color: #fff;
  opacity: 0.75;
}

.pswp__button--trash a:hover,
.pswp__button--download a:hover {
  opacity: 1;
  color: #ffffff;
  transition: opacity 0.2s;
}

button:focus {
  outline: 0;
}

.pswp__container,
.pswp__img {
  /* 讓 ios 可以長按下載圖片 */
  -webkit-touch-callout: default;
}

// 兩張圖片的情況
.picture-2 {
  width: 100%;
  height: 50vw;
  overflow: hidden;
}

// 三張圖片的情況 - 下面兩張圖的版型
.picture-3 {
  width: 50%;
  height: 50vw;
  overflow: hidden;
}

// 三張圖片的情況 - 第一張圖的版型
.picture-3:first-child {
  width: 100%;
  height: 50vw;
  overflow: hidden;
}

// 四張圖片的情況
.picture-4 {
  width: 50%;
  height: 180px;
  overflow: hidden;
}

// 超過四張圖片的情況
.picture-5 {
  width: 50%;
  height: 180px;
  overflow: hidden;
}

.picture-5:nth-child(4)::before {
  position: absolute;
  content: '';
  background-color: #000;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  color: #fff;
}

.more-picture {
  position: absolute;
  top: 50%;
  color: #fff;
  font-size: 34px;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
}
</style>

<!-- 全域 -->
<style>
.pswp img {
  max-width: none;
  object-fit: contain;
}
</style>
